import PropTypes from "prop-types";
import SlideIn from "../../../Components/SlideIn/SlideIn";
import HowPetitionsMatterContent from "./HowPetitionsMatterContent";
import PetitionsContactFooter from "./PetitionsContactFooter";

const HowPetitionsMatterSlideIn = ({ close }) => (
  <SlideIn
    close={close}
    contents={<HowPetitionsMatterContent />}
    footer={<PetitionsContactFooter />}
  />
);

HowPetitionsMatterSlideIn.propTypes = {
  close: PropTypes.func,
};

export default HowPetitionsMatterSlideIn;
